export enum ALERT_TYPE {
  VIDEO_LOADING_ALERT = 'VideoLoadingAlert',
  VIDEO_SIZE_ALERT = 'VideoSizeAlert',
  FILE_SIZE_ALERT = 'FileSizeAlert',
}
